import request from "@/utils/request";

export default function changeIsOpenLongpress(params) {
    return request({
        url: `/storeProduct/changeIsOpenLongpress`,
        method: 'get',
        params: params,
    })
}
